import axios, { AxiosPromise } from 'axios';
import { IAkcionarVHHlasovani } from 'types/akcionar';

import { EAdmissionConditionsEnums } from 'enums/akcionarKorpAkce/admissionConditionsEnums';
import { EKvorumEnums } from 'enums/akcionarKorpAkce/kvorumEnums';
import { EProxyTypeEnums } from 'enums/akcionarKorpAkce/proxyTypeEnums';
import { ETypVH } from 'enums/akcionarKorpAkce/typVH';
import { EVotetp } from 'enums/akcionarKorpAkce/votetp';
import { EZpusob } from 'enums/akcionarKorpAkce/zpusob';
import apiPaths from 'enums/apiPaths';

export interface IPruvodceVH {
    mtgid?: string;
    isin?: string;
    typvh?: ETypVH;
    datumkonani?: string;
    rozhodnyden?: string;
    leiemitent?: string;
    urlschuzky?: string;
    mistokonanivh?: {
        ulice?: string;
        mesto?: string;
        psc?: string;
        stat?: string;
    };
    ucastvh: IPruvodceVHUcastvh[];
    bodyvh: IPruvodceVHBodyvh[];
    typpruvodce?: 'NEWM' | 'REPL';
}
export interface IPruvodceVHUcastvh {
    zpusob?: EZpusob;
    datumoznameni?: string;
    mail?: {
        ulice?: string;
        mesto?: string;
        psc?: string;
        stat?: string;
        email?: string;
    };
    evot?: IEvot[];
    typfyzucasti?: EAdmissionConditionsEnums;
    proxytype?: EProxyTypeEnums;
}
interface IEvot {
    url?: string;
    bic?: string;
    druh?: 'BIC' | 'CHANNEL';
    channel?: 'VOCI' | 'VOPI';
}

export enum ETypPrahu {
    ALSH = 'ALSH',
    ALSM = 'ALSM',
    ALVO = 'ALVO'
}
export interface IPruvodceVHBodyvh {
    isssrlabl?: string;
    titl?: string;
    titlen?: string;
    desc?: string;
    descen?: string;
    forinfonly?: boolean;
    votetp?: EVotetp;
    urladdress?: string;
    hlasovani?: IAkcionarVHHlasovani[];
    kvorum?: {
        pocet?: string;
        procenta?: string;
        typprahu?: ETypPrahu;
    };
    kvorumtype?: EKvorumEnums | '';
    kvorumamount?: string;
    typprahu?: ETypPrahu;
}

export const pruvodceVHGETApi = (id: number): AxiosPromise<IPruvodceVH> => {
    return axios({
        method: 'GET',
        url: `SRD/${id}${apiPaths.PRUVODCE_VH}`
    });
};

export const pruvodceVHPUTApi = (
    id: number,
    data: IPruvodceVH,
    typpruvodce: 'NEWM' | 'REPL'
): AxiosPromise<IPruvodceVH> => {
    return axios({
        method: 'PUT',
        url: `SRD/${id}${apiPaths.PRUVODCE_VH}`,
        data: {
            ...data,
            typpruvodce: typpruvodce
        }
    });
};

export const pruvodceVHPOSTApi = (
    id: number,
    data: IPruvodceVH,
    typpruvodce: 'NEWM' | 'REPL'
): AxiosPromise<{ datum: string; upozor: { typ: string }[] }> => {
    return axios({
        method: 'POST',
        url: `SRD/${id}${apiPaths.PRUVODCE_VH}`,
        data: {
            ...data,
            typpruvodce: typpruvodce
        }
    });
};

export const pruvodceVHcertApi = (
    id: number,
    data: IPruvodceVH,
    typpruvodce: 'NEWM' | 'REPL'
): AxiosPromise<{ datum: string; upozor: { typ: string }[] }> => {
    return axios({
        method: 'POST',
        url: `SRD/pruvodceVH/Cert/${id}`,
        data: {
            ...data,
            typpruvodce: typpruvodce
        }
    });
};
